module.exports = {
	"usdFull": "USD - US Dollar",
	"cadFull": "CAD - Canadian Dollar",
	"eurFull": "EUR - Euro",
	"gbpFull": "GBP - Britsh Pound",
	"audFull": "AUD - Australian Dollar",
	"inrFull": "INR - Indian Rupee",
	"jpyFull": "JPY - Yens"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/currency.json5
// module id = 1925
// module chunks = 6